var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuidences(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 168,
    viewBox: "0 0 160 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_142)",
    filter: "url(#filter0_d_3_142)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3_142",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 160,
    height: 160
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M160 0H0V160H160V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3_142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80 155C121.421 155 155 121.421 155 80C155 38.5786 121.421 5 80 5C38.5786 5 5 38.5786 5 80C5 121.421 38.5786 155 80 155Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.5 104C104.684 104 81 109.85 81 121.5V129C81 131.75 83.2821 134 86.0714 134H146.929C149.718 134 152 131.75 152 129V121.5C152 109.85 128.316 104 116.5 104Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5 92C44.025 92 9 100.775 9 118.25V129.5C9 133.625 12.375 137 16.5 137H106.5C110.625 137 114 133.625 114 129.5V118.25C114 100.775 78.975 92 61.5 92Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 54.5C84 66.95 74.0084 77 61.5376 77C49.0668 77 39 66.95 39 54.5C39 42.05 49.0668 32 61.5376 32C74.0084 32 84 42.05 84 54.5Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132 78C132 86.3 125.117 93 116.526 93C107.935 93 101 86.3 101 78C101 69.7 107.935 63 116.526 63C125.117 63 132 69.7 132 78Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.875 112.25H85.125V152.75H37.875V112.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.875 105.5H31.125C27.4125 105.5 24.375 108.537 24.375 112.25V152.75C24.375 156.463 27.4125 159.5 31.125 159.5H91.875C95.5875 159.5 98.5912 156.463 98.5912 152.75L98.625 112.25C98.625 108.537 95.5875 105.5 91.875 105.5ZM85.125 152.75H37.875V112.25H85.125V152.75Z",
    fill: "#032746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 118H66C67.1046 118 68 118.895 68 120C68 121.105 67.1046 122 66 122H46C44.8954 122 44 121.105 44 120C44 118.895 44.8954 118 46 118Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 126H66C67.1046 126 68 126.895 68 128C68 129.105 67.1046 130 66 130H46C44.8954 130 44 129.105 44 128C44 126.895 44.8954 126 46 126Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 134H77C78.1046 134 79 134.895 79 136C79 137.105 78.1046 138 77 138H46C44.8954 138 44 137.105 44 136C44 134.895 44.8954 134 46 134Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46 142H77C78.1046 142 79 142.895 79 144C79 145.105 78.1046 146 77 146H46C44.8954 146 44 145.105 44 144C44 142.895 44.8954 142 46 142Z",
    fill: "#DFE3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.2469 120.198V127.545C74.2469 128.221 74.7786 128.753 75.4553 128.753H82.8019C83.1161 128.753 83.4303 128.632 83.6478 128.39L110.038 102.025L100.975 92.9621L74.6094 119.328C74.3678 119.57 74.2469 119.86 74.2469 120.198ZM117.046 95.0162C117.989 94.0737 117.989 92.5512 117.046 91.6087L111.391 85.9537C110.449 85.0112 108.926 85.0112 107.984 85.9537L103.561 90.3762L112.624 99.4387L117.046 95.0162Z",
    fill: "#B10303"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_142",
    x: -4,
    y: 0,
    width: 168,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_142"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_142",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidences);
export default __webpack_public_path__ + "static/media/Guidences.b030b7a579808e1c7d0245990541339b.svg";
export { ForwardRef as ReactComponent };